import { LucideIcon } from 'lucide-react';
import React from 'react';
import { ThemeColors } from '../../../shared/hooks/useCustomerInfo';

interface SimpleInputProps {
  name: keyof any;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  colors: ThemeColors;
  icon?: LucideIcon;
  type?: 'text' | 'email' | 'tel';
  className?: string;
}

interface SimplePhoneInputProps extends Omit<SimpleInputProps, 'onChange'> {
  onChange: (value: string) => void;
}

// Simple Text Input Component
export const SimpleTextInput: React.FC<SimpleInputProps> = ({
  name,
  placeholder,
  value,
  onChange,
  onBlur,
  colors,
  icon: Icon,
  type = 'text',
  className = ""
}) => {
  return (
    <div className={`relative ${className}`}>
      {Icon && (
        <Icon
          className="absolute left-3 top-1/2 transform -translate-y-1/2 opacity-60"
          size={16}
          style={{ color: colors.iconColor }}
        />
      )}
      <input
        type={type}
        name={name as string}
        placeholder={placeholder}
        className={`w-full rounded-lg px-3 py-2 ${Icon ? 'pl-10' : ''} focus:outline-none text-sm`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        style={{
          backgroundColor: colors.inputBackground,
          color: colors.inputText,
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: colors.inputBorder
        }}
      />
    </div>
  );
};

// Simple Name Inputs (First Name + Last Name side by side)
export const SimpleNameInputs: React.FC<{
  firstNameValue: string;
  lastNameValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFirstNameBlur: () => void;
  onLastNameBlur: () => void;
  colors: ThemeColors;
}> = ({
  firstNameValue,
  lastNameValue,
  onChange,
  onFirstNameBlur,
  onLastNameBlur,
  colors
}) => {
  return (
    <div className="flex space-x-2">
      <div className="w-1/2">
        <input
          type="text"
          name="firstName"
          placeholder="First Name"
          className="w-full rounded-lg px-3 py-2 focus:outline-none text-sm"
          value={firstNameValue}
          onChange={onChange}
          onBlur={onFirstNameBlur}
          style={{
            backgroundColor: colors.inputBackground,
            color: colors.inputText,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: colors.inputBorder
          }}
        />
      </div>
      <div className="w-1/2">
        <input
          type="text"
          name="lastName"
          placeholder="Last Name"
          className="w-full rounded-lg px-3 py-2 focus:outline-none text-sm"
          value={lastNameValue}
          onChange={onChange}
          onBlur={onLastNameBlur}
          style={{
            backgroundColor: colors.inputBackground,
            color: colors.inputText,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: colors.inputBorder
          }}
        />
      </div>
    </div>
  );
};
